
import React from 'react';
const emotionEmojiMap = {
  "anger": "😠",
  "joy": "😄",
  "fear": "😨",
  "sadness": "😢",
  "neutral": "😐"
};
const TrustSummaryView = ({ result }) => {
  if (!result) return null;

  const {
    text = "",
    emotion = "N/A",
    severity = "NONE",
    zeta_score,
    alerts = [],
    timestamp = ""
  } = result;



 
  let formattedDate = "Invalid Date";
  try {
    const safeTimestamp = timestamp.split('.')[0];
    const parsedDate = new Date(safeTimestamp);
    if (!isNaN(parsedDate.getTime())) {
      formattedDate = parsedDate.toLocaleString();
    }
  } catch (err) {
    console.warn('Date parse failed', err);
  }

  const trustScore = (typeof zeta_score === 'number' && !isNaN(zeta_score))
    ? Math.round(zeta_score * 100)
    : null;

  const emoji = emotionEmojiMap[emotion.toLowerCase()] || "❓";
  return (
    <div style={styles.card}>
      <h2 style={styles.heading}>🎯 Trust Analysis Summary</h2>

      <div style={styles.row}>
        <p><strong>🧭 Trust Score:</strong></p>
        <p style={getScoreStyle(trustScore)}>{trustScore !== null ? `${trustScore}%` : "N/A"}</p>
      </div>

      <div style={styles.row}>
        <p style={styles.label}>
          <strong>{emoji} Emotion Detected:</strong>
        </p>
        <p style={styles.value}>{emotion}</p>
      </div>

      <div style={styles.row}>
        <p><strong>⚠️ Severity:</strong></p>
        <p style={getSeverityStyle(severity)}>{severity}</p>
      </div>

      <div style={styles.row}>
        <p><strong>📅 Timestamp:</strong></p>
        <p style={styles.value}>{formattedDate}</p>
      </div>

      <div style={styles.section}>
        <h3 style={styles.subheading}>📝 Notes</h3>
        <p style={styles.note}>{text}</p>
      </div>

      <div style={styles.alertBox}>
        <h3 style={styles.alertHeading}>🚨 Emergency Alert</h3>
        <ul style={styles.alertList}>
          {alerts.map((alert, idx) => (
            <li key={idx} style={styles.alertItem}>{alert}</li>
          ))}
        </ul>
      </div>

    </div>
  );
};

const getScoreStyle = (score) => ({
  color: score >= 80 ? '#2e7d32' : score >= 50 ? '#f9a825' : '#c62828',
  fontWeight: 'bold',
  fontSize: '18px',
});

const getSeverityStyle = (level) => ({
  color:
    level === 'HIGH' ? '#d32f2f' :
      level === 'MEDIUM' ? '#f57c00' :
        level === 'LOW' ? '#388e3c' : '#616161',
  fontWeight: 'bold',
  fontSize: '18px',
});

const styles = {
  card: {
    backgroundColor: '#ffffff',
    padding: '24px',
    borderRadius: '16px',
    boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
    maxWidth: '600px',
    width:'80%',
    margin: '30px auto',
    fontFamily: 'Segoe UI, sans-serif',
  },
  heading: {
    fontSize: '24px',
    fontWeight: '600',
    marginBottom: '20px',
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '12px',
    fontSize: '18px',
  },
  value: {
    fontWeight: '500',
    color: '#333',
  },
  section: {
    marginTop: '24px',
  },
  subheading: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '10px',
  },
  note: {
    backgroundColor: '#f4f4f4',
    padding: '12px',
    borderRadius: '8px',
    fontSize: '16px',
    color: '#444',
    lineHeight: '1.5',
  },

  alertHeading: {
    color: '#b71c1c',
    fontSize: '18px',
    fontWeight: '700',
    marginBottom: '10px',
  },
  alertList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    marginLeft:'20px',
  },
alertBox: {
  marginTop: '30px',
  backgroundColor: '#fff3f3',
  border: '1px solid #f44336',
  borderRadius: '10px',
  padding: '10px',
  display: 'flex',
  flexDirection: 'column', 
  gap: '10px'
},

};

export default TrustSummaryView;

